import {
  EWithdrawalChannel,
  EWithdrawalEntryPoint,
  EWithdrawalOrderLinkSource,
  EWithdrawalStatus,
} from '@mahawi/eshop-common/src/types';

export const WITHDRAWAL_STATUS_LABEL: Record<EWithdrawalStatus, string> = {
  [EWithdrawalStatus.RECEIVED]: 'Received',
  [EWithdrawalStatus.GOODS_RECEIVED]: 'Goods received',
  [EWithdrawalStatus.MONEY_REFUNDED]: 'Money refunded',
  [EWithdrawalStatus.REJECTED]: 'Rejected',
  [EWithdrawalStatus.ORDER_CANCELLED]: 'Order cancelled',
};

export const WITHDRAWAL_CHANNEL_LABEL: Record<EWithdrawalChannel, string> = {
  [EWithdrawalChannel.ONLINE_FORM]: 'Online form',
  [EWithdrawalChannel.EMAIL]: 'Email',
  [EWithdrawalChannel.LETTER]: 'Letter',
  [EWithdrawalChannel.PHONE]: 'Phone',
  [EWithdrawalChannel.OTHER]: 'Other',
};

export const WITHDRAWAL_ENTRY_POINT_LABEL: Record<
  EWithdrawalEntryPoint,
  string
> = {
  [EWithdrawalEntryPoint.STOREFRONT]: 'Storefront footer',
  [EWithdrawalEntryPoint.CUSTOMER_ACCOUNT]: 'Customer account',
  [EWithdrawalEntryPoint.ORDER_PAID_EMAIL]: 'Order paid email',
  [EWithdrawalEntryPoint.ORDER_SHIPPED_EMAIL]: 'Order shipped email',
};

export const WITHDRAWAL_ORDER_LINK_SOURCE_LABEL: Record<
  EWithdrawalOrderLinkSource,
  string
> = {
  [EWithdrawalOrderLinkSource.AUTOMATIC_MATCH]: 'Automatic match',
  [EWithdrawalOrderLinkSource.ORDER_LINK]: 'Order-specific link',
  [EWithdrawalOrderLinkSource.STAFF]: 'Linked by staff',
};

export const WITHDRAWAL_OPEN_STATUSES: EWithdrawalStatus[] = [
  EWithdrawalStatus.RECEIVED,
  EWithdrawalStatus.GOODS_RECEIVED,
];
